module.exports = __webpack_public_path__ + "assets/ic-calendar_inverted.67c62eb2.svg";